module.exports = __webpack_public_path__ + "img/empowered.c71fbd59.png";